import axios from "axios";

export default axios.create({
  baseURL: "https://us-central1-beauty-by-me-4fc72.cloudfunctions.net",
  headers: {
    "Content-Type": "application/json",
    "Access-Control-Allow-Origin": "*",
  },
});
